import { colors } from '@chegg-ui/theme'
import styled from 'styled-components'
import { adjust, themeBreakPoints, smallLayout } from '@chegg-wt/core/theme/theme'
import { SpecialOutlineButtonLink } from '@chegg-wt/core/theme/fanta/button'
import { Heading2, BodyMedium } from '@chegg-wt/core/theme/sunkist/typography'
import { Advert } from '../Advert'

export const Container = styled.section`
  background-color: ${({ theme }) => theme.Colors.forInterface.interfaceColor20};
`
export const Wrapper = styled.div`
  margin-left: auto;
  margin-right: auto;
  padding: 8px;
  max-width: 900px;
  @media (min-width: ${(props) => adjust(themeBreakPoints.extraSmall(props.theme), 20)}) {
    padding: 16px 32px;
  }
  @media (max-width: ${(props) => smallLayout(props.theme)}) {
    padding: 16px;
  }
`

export const UpgradeContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
  margin-top: 16px;
  padding-top: 16px;

  // Creates a gap between CTA and Ad
  & > * + * {
    margin-left: 4%;
  }
`

export const CardWrapper = styled.div.attrs({
  role: 'region',
  'aria-label': 'Upgrade Card',
})`
  min-width: 300px;
  flex: 0 0 48%;
`

export const CenteredAdvert = styled(Advert)`
  flex: 0 0 48%;
  &&& {
    display: flex;
    justify-content: flex-end;
    overflow: visible;
  }
`

export const RedirectButton = styled(SpecialOutlineButtonLink)`
  margin-top: 15px;
  margin-bottom: auto;
  cursor: pointer;
`

export const ListHeader = styled.h2`
  ${Heading2}
`

export const ListMultiHeader = styled.h2`
  ${Heading2}
  margin: 0;
`
export const ListHeaderWrapper = styled.div`
  margin-top: 20px;
  margin-bottom: 10px;
`

export const List = styled.ul`
  margin-bottom: 10px;
  width: 100%;
`

export const BulletPoint = styled.li`
  ${BodyMedium};
  padding: 3px;
  ::before {
    content: '•';
    color: ${({ theme }) => theme.Colors.forInterface.interfaceColor06};
    display: inline-block;
    width: 1.5em;
  }
`

export const TermsWrapper = styled.div`
  padding-top: 10px;
`

export const TermsAndConditions = styled.a`
  font-size: 14px;
  text-align: center;
  text-decoration: none;
  font-weight: 700;
  color: ${colors.link};
`
